import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {queryClientList, getMediaWallList} from '@apis'
import * as G2 from '@antv/g2'

const NodeOnlineRate = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [unonlineList, setUnonlineList] = useState([])

    // 获取节点信息
    async function queryMediaWallList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        getClientList(res.data)
      }
    }

    // 获取节点监控信息
    async function getClientList(nodeList) {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await queryClientList(params)
      if (res && res.data) {
        let client = []
        nodeList.map(item => {
          res.data.data.map(value => {
            if(value.appCode == item.code) {
              client.push({
                ...value,
                id: item.id,
                name: item.name
              })
            }
          })
        })
        const total = client.length
        const offlineList = client.filter(item => new Date(item.dateTime).valueOf()+5*60*1000<new Date().valueOf())
        const offlinePercent = (offlineList.length / total).toFixed(4)
        const onlinePercent = 1 - offlinePercent
        const rateData = [
          {item: '在线', count: total-offlineList.length, percent: Number(onlinePercent)},
          {item: '离线', count: offlineList.length, percent: Number(offlinePercent)}
        ]
        setUnonlineList(offlineList)
        creatChat(rateData, total)
      }
    }

    useEffect(() => {
      queryMediaWallList()
    }, [])
 
    function creatChat(data, totalData) {
      const chart = new G2.Chart({
        container: 'node-container',
        autoFit: true,
        height: 240,
      });
      chart.data(data);
      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });
      chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.75,
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
      });
      // 辅助文本
      chart
        .annotation()
        .text({
          position: ['50%', '50%'],
          content: (data[0].percent*100).toFixed(2) + '%',
          style: {
            fontSize: 30,
            fill: 'rgb(17, 235, 200)',
            textAlign: 'center',
          },
          offsetY: -10,
        })
        .text({
          position: ['50%', '50%'],
          content: '运行率',
          style: {
            fontSize: 18,
            fill: '#fff',
            textAlign: 'center',
          },
          offsetY: 14,
        })
      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('item', ['#03bde9', 'red'])
        .label('percent', (percent) => {
          return {
            content: (data) => {
              return `${data.item}: ${(percent * totalData).toFixed(0)}`;
            },
            style: {
              fill: '#fff',
              fontSize: 18
            }
          };
        })
        .tooltip('item*percent', (item, percent) => {
          percent = percent * totalData;
          return {
            name: item,
            value: percent,
          };
        });
      chart.legend({
        // position: 'left',
        itemName: {
          style: {
            fontSize: 12,
            fill: '#fff'
          }
        }
      })
  
      chart.interaction('element-active');
  
      chart.render();
    }

    return (
      <div className='ck-node-online'>
        <div className='title'>监控在线率</div>
        <div className='node-item'>
          <div id='node-container' className='node-chat'></div>
          <div className='node-unonline'>
            <div className='unonline-title'>
              <span>离线</span>
              <span className='littleTitle'>来源</span>
            </div>
            <div className='unonline-index'>
              {
                unonlineList.map(item => (
                  <div className='unonline-content'>
                    <span>{item.dateTime}</span>
                    <span className='littleTitle'>{item.name}</span>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default NodeOnlineRate